import usingServiceAdvantage from './usingBarsAdvantage';
import frequentlyAskedQuestions from './bars-frequentlyAskedQuestions';
const SectionContent = {
  topSection: {
    en: {
      title: 'Bar POS System',
      description: `Upgrade your operations and customer experiences – from bar-top to table-top.`,
    },
    zh: {
      title: '酒吧',
      description: '从吧台到桌前都升级您的运营效率和顾客体验',
    },
  },
  everythingNeedInOnePOSSystem: {
    en: {
      title: 'Recommended products to power your Bar',
    },
    zh: {
      title: '推荐使用的POS产品',
    },
  },
  usingServiceAdvantage: {
    ...usingServiceAdvantage,
  },
  frequentlyAskedQuestions: {
    ...frequentlyAskedQuestions,
  },
};

export default SectionContent;
